import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { confirmDialog } from "primereact/confirmdialog";

import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';
import moment from "moment";

import "./index.css"

import { Dialog } from "primereact/dialog";
import { Button } from "../../helpers";
import Menu from "../../helpers/Menu";
import Loading from "../../common/Loading";
import GenerateEwayBill from "../GenerateEwayBill";

import CancelCreditNoteModal from "./Components/CancelCreditNoteModal";

import { getDocCopyByDocNo } from "../../services/api/docCopy";
import { getBuyerInvoiceById } from "../../services/api/buyerInvoice";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";
import { getBuyerInvoiceItems } from "../../services/api/buyerInvoiceItem";
import { assignDocNoToAdjustmentNote, cancelBuyerCreditNoteEInvoice, generateBuyerCreditNoteEInvoice, getAdjustmentNoteById, getAdjustmenyNoteByLinkedDocNo, getBuyerCreditNoteDocument } from "../../services/api/adjustmentNotes";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getDocItemReplacementLogByDocId } from "../../services/api/docItemReplacementLog";
import { getDocItemReplacementMapByIds } from "../../services/api/docItemReplacementMap";

import { fetchApprovals } from "../../services/redux/reducers/commonThunk";
import { getUsers } from "../../services/api/user";
import { getApprovalInstances, insertApprovalInstances, updateApprovalInstance } from "../../services/api/approvalInstances";
import { getAdjustmentReasons } from "../../services/api/adjustmentReasons";
import EInvoiceDetails from "../../common/eInvoiceDetails";
import { calculateBuyerAdjustmentNote } from "../../utils";
import downloadFile from "../../utils/DownloadFile";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";

import DocumentView from "../../common/DocumentView";


function CreditNoteDocument() {
    const { adjustmentNoteId } = useParams()

    const [isEwayBillVisible, setIsEwayBillVisible] = useState(false)
    const [visibleCancelCreditNote, setVisibleCancelCreditNote] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isPDFLoading, setIsPDFLoading] = useState(false)
    const [isPageLoading, setIsPageLoading] = useState(false)

    const [adjustmentNote, setAdjustmentNote] = useState({})
    const [adjustmentReasons, setAdjustmentReasons] = useState([])
    const [cancelRemarks, setCancelRemarks] = useState('')
    const [adjustmentNoteItems, setAdjustmentNoteItems] = useState([])
    const [buyerCreditNoteHTML, setBuyerCreditNoteHTML] = useState("")
    const [buyerInvoice, setBuyerInvoice] = useState({})
    const [buyerInvoiceItems, setBuyerInvoiceItems] = useState([])
    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [buyerBillAddrDetails, setBuyerBillAddrDetails] = useState({})
    const [buyerShipAddrDetails, setBuyerShipAddrDetails] = useState({})
    const [PMBankAccountDetails, setPMBankAccountDetails] = useState({})
    const [materialDetails, setMaterialDetails] = useState([])
    const [adjustmentNotePDFURL, setAdjustmentNotePDFURL] = useState(null)
    const [eWayBillInvoiceObj, setEWayBillInvoiceObj] = useState({})
    const [eWayBillProductDetails, setEWayBillProductDetails] = useState([])
    const [linkedSellerDebitNote, setLinkedSellerDebitNote] = useState(null)

    const [creditNoteApproverDetails, setCreditNoteApproverDetails] = useState({})
    const [approvalInstance, setApprovalInstance] = useState({})
    const [visibleEInvoiceDetails, setVisibleEInvoiceDetails] = useState(false)

    const actionMenu = useRef(null)

    const statesList = useSelector(state => state.common.states)
    const approvals = useSelector(state => state.common.approvals)
    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(buyerInvoice?.pmCompanyId)

    const dispatch = useDispatch()

    let CNDNApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.CNDNApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    useEffect(() => {
        dispatch(fetchApprovals())
        getAdjustmentReasonsData()
    }, [])

    useEffect(() => {
        if(CNDNApprovals?.length > 0){
            getAdjustmentNoteDetails()
        }
    }, [adjustmentNoteId, CNDNApprovals])

    let canDocumentDownloaded = false
    let canCreateEwayBill = false

    if([1, 3, 4].includes(adjustmentNote?.supplyTypeId) && adjustmentNote?.IRN){
        canDocumentDownloaded = true
    }
    if([2].includes(adjustmentNote?.supplyTypeId)){
        canDocumentDownloaded = true
    }

    if(adjustmentNote?.statusId === 6){ // CANCELLED
        canDocumentDownloaded = true
    } else {
        canCreateEwayBill = true
    }

    if(adjustmentNote?.statusId === 7){
        canDocumentDownloaded = false
        canCreateEwayBill = false
    }

    const actionMenuItems = [
        {
            label: approvalInstance?.approvalInstanceId ? "Approval Requested" : "Request Approval",
            visible: adjustmentNote?.statusId === 7 && !approvalInstance?.approvalInstanceId,
            command: () => {
                handleApproveAdjustmentNote()
            },
            //permissions: [45],  //Need to change permissions?
            disabled: isLoading || isPDFLoading || isPageLoading || approvalInstance?.statusId === 12
        },
        {
            label: "Generate E-invoice",
            visible: ![6, 7].includes(adjustmentNote?.statusId) && [1, 3, 4].includes(adjustmentNote?.supplyTypeId) && !adjustmentNote?.IRN && pmCompanyConfig.isEInvoiceRequired,
            command: () => {
                handleGenerateEInvoice()
            },
            permissions: [44],
            disabled: isLoading || isPDFLoading || isPageLoading
        },
        {
            label: "Generate Invoice",
            visible: ![6, 7].includes(adjustmentNote?.statusId) && [1, 3, 4].includes(adjustmentNote?.supplyTypeId) && !adjustmentNote?.IRN && pmCompanyConfig.isEInvoiceRequired,
            command: () => {
                handleGenerateEInvoice()
            },
            permissions: [44],
            disabled: isLoading || isPDFLoading || isPageLoading
        },
        {
            label: "Generate Credit/Debit Note",
            visible: !approvalInstance?.statusId !== 9 && false && [1, 7].includes(adjustmentNote?.statusId) && !adjustmentNote?.docNo && !pmCompanyConfig.isEInvoiceRequired,
            command: () => {
                handleAssignDocNoToAdjustmentNote()
            },
            permissions: [44]
        },
        {
            label: isPDFLoading ? "Loading..." : adjustmentNote?.adjustmentTypeId === 1 ? "Download Credit Note" : "Download Debit Note",
            visible: canDocumentDownloaded,
            command: () => {
                if(adjustmentNotePDFURL){
                    let fileName =  adjustmentNote?.adjustmentTypeId === 1 ? "buyerCreditNote.pdf" : "buyerDebitNote.pdf"
                    downloadFile(adjustmentNotePDFURL, fileName)
                }
                else{
                    setIsPDFLoading(true)
                    getBuyerCreditNotePDFURL()
                }
            },
            disabled: isLoading || isPDFLoading || isPageLoading
        },
        {
            label: 'Generate E-Way Bill',
            command : async () => {
                handleGenerateEwayBill()
            },
            permissions: [46],
            visible: false, //adjustmentNote?.adjustmentTypeId === 1 && canCreateEwayBill ? true : false,
            disabled: true
            // disabled: isLoading || isPDFLoading || isPageLoading
        },
        {
            label: adjustmentNote?.adjustmentTypeId === 1 ? "Cancel Credit Note" : "Cancel Debit Note",
            className: "cancel-btn",
            command: () => setVisibleCancelCreditNote(true),            
            permissions: [47],
            visible: ![6].includes(adjustmentNote?.statusId),
            disabled: isLoading || isPDFLoading || isPageLoading
        },
        {
            label: "Regenerate Document",
            className: "cancel-btn",
            command: () => regenerateDocCopy(),            
            permissions: [47],
            visible: [6, 1].includes(adjustmentNote?.statusId) && [1, 3, 4].includes(adjustmentNote?.supplyTypeId) && (adjustmentNote?.IRN ? true : false),
            disabled: isLoading || isPDFLoading || isPageLoading
        }
    ]

    const regenerateDocCopy = async () => {
        if(!window.confirm("Confirm to regenerate document")){
            return
        }

        setIsLoading(true)

        const createNewDocCopy = true
        const docCopyRes = await getDocCopyByDocNo(adjustmentNote.docNo, null, createNewDocCopy)

        if(docCopyRes.failure){
            dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error, life: 3000}))
        }else{
            setAdjustmentNotePDFURL(docCopyRes.docLocation)
        }

        setIsLoading(false)
    }

    const handleAssignDocNoToAdjustmentNote = async () => {
        if(!window.confirm("Confirm to generate Buyer Credit/Debit Note")){
            return
        }

        setIsLoading(true)
        const adjustmentNoteRes = await assignDocNoToAdjustmentNote(adjustmentNote.adjustmentNoteId)
        setIsLoading(false)

        if (adjustmentNoteRes.failure) {
            dispatch(raiseToast({ severity: 'error', summary: "Doc No Assignment", detail: adjustmentNoteRes.data.error }))
        } else {
            console.log("handleAssignDocNoToAdjustmentNote", adjustmentNoteRes)
            getAdjustmentNoteDetails()
        }
    }

    const getAdjustmentReasonsData = async() => {
        let adjustmentReasonsResponse = await getAdjustmentReasons({adjustmentReasonName:"ASC", paginator:false})
        if(adjustmentReasonsResponse.failure){
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', detail: adjustmentReasonsResponse.data.error, life: 3000}))
        }else{
            setAdjustmentReasons(adjustmentReasonsResponse.data.data)
        }
    }

    const handleApproveAdjustmentNote = async () => {
        let calculateAdjustmentNote = calculateBuyerAdjustmentNote(adjustmentNote, adjustmentNoteItems, buyerInvoice, buyerInvoiceItems)

        let relatedAdjustedReason = adjustmentReasons.find(eachAdjustmentReason => eachAdjustmentReason.adjustmentReasonId === adjustmentNote.adjustmentReasonId)
        console.log("abndbn", CNDNApprovals)
        //Create approve instance
        let relatedApproval 
        if (adjustmentNote?.returnToSeller || relatedAdjustedReason?.adjustmentReasonId === 7){
            relatedApproval = CNDNApprovals.find(eachApr => eachApr.approvalTypeId === 8) // APPROVAL_CHANGE find by typeId
        }else{
            relatedApproval = CNDNApprovals.find(eachApr => eachApr.approvalTypeId === 12) // APPROVAL_CHANGE find by typeId
        }

        const newApprovalInstance = {
            approvalId: relatedApproval.approvalId,
            docNo: adjustmentNote?.docNo ? adjustmentNote.docNo : null,
            parentDocNo: buyerInvoice.docNo,
            approvedMetrics: {amount: calculateAdjustmentNote.adjustmentNote.totalAmountWithTax},
            sellerCompanyId: buyerInvoice.pmCompanyId,
            buyerCompanyId: buyerInvoice.companyId,
            pmBranchId: buyerInvoice.pmBranchId,
            docId: adjustmentNoteId,
            docTypeId: adjustmentNote?.adjustmentTypeId === 1 ? 21 : 22,
            statusId: 12,
            createdBy: userDetails.userId,
            remarks: adjustmentNote.remarks ? adjustmentNote.remarks : ""
        }
        if(relatedAdjustedReason){
            newApprovalInstance.remarks += "\n Adjustment Reason: " + relatedAdjustedReason.adjustmentReasonName
        }
        
        const toBeRefilled = adjustmentNote.toBeRefilled ? "Yes" : "No"
        newApprovalInstance.remarks += ", \n " + "Refilled: " + toBeRefilled

        const returnToSeller = adjustmentNote.returnToSeller ? "Yes" : "No"
        newApprovalInstance.remarks += ", \n " + "Return To Vendor: " + returnToSeller
        

        if (window.confirm(`Confirm to raise approval request`)){ 
            setIsPageLoading(true)

            let successToastMessage = adjustmentNote?.adjustmentTypeId === 1 ? "Request raised successfully" : "Request raised successfully"

            const newApprovalInstacesRes = await insertApprovalInstances({ requestedApprovals: [newApprovalInstance] })
            if (newApprovalInstacesRes.failure) {
                setIsPageLoading(false)
                return dispatch(raiseToast({ severity: 'error', detail: newApprovalInstacesRes.data.error }))
            }
            else{
                dispatch(raiseToast({severity:'success', detail: successToastMessage}))
                setApprovalInstance(newApprovalInstacesRes.data[0])
                getAdjustmentNoteDetails()
            }
            setIsPageLoading(false)
        }
    }

    const getAdjustmentNoteDetails = async () => {
        const adjustmentNoteRes = await getAdjustmentNoteById(adjustmentNoteId)
        if(adjustmentNoteRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', summary: 'Adjustment Note details', detail: adjustmentNoteRes.data.error, life: 3000}))
        }
        setAdjustmentNote(adjustmentNoteRes.data?.adjustmentNotes)
        setAdjustmentNoteItems(adjustmentNoteRes.data?.adjustmentNoteItems)

        let buyerInvoiceRes = {}

        if(adjustmentNoteRes.data?.adjustmentNotes?.buyerInvoiceId){
            const buyerCreditNoteDocRes = await getBuyerCreditNoteDocument(adjustmentNoteId)
            console.log("buyerCreditNoteDocRes", buyerCreditNoteDocRes)
            if (buyerCreditNoteDocRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Adjustment Note Doc', detail: buyerCreditNoteDocRes.data.error, life: 3000}))
            }

            if(buyerCreditNoteDocRes.data.docCopy){
                setAdjustmentNotePDFURL(buyerCreditNoteDocRes.data.docCopy.docLocation)
            } else {
                setBuyerCreditNoteHTML(buyerCreditNoteDocRes.data.documentHTML)
            }

            buyerInvoiceRes = await getBuyerInvoiceById(adjustmentNoteRes?.data?.adjustmentNotes?.buyerInvoiceId)
            if (buyerInvoiceRes?.data?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Buyer Invoice', detail: buyerInvoiceRes.data.error, life: 3000}))
            }

            const buyerInvoiceItemsRes = await getBuyerInvoiceItems({ buyerInvoiceIds : [buyerInvoiceRes?.data?.buyerInvoice?.buyerInvoiceId], paginator : false})
            if (buyerInvoiceItemsRes?.data?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Buyer Invoice Items', detail: buyerInvoiceRes.data.error, life: 3000}))
            }

            const docItemReplacementLogRes = await getDocItemReplacementLogByDocId({ docId : buyerInvoiceRes?.data?.buyerInvoice?.buyerInvoiceId})
    
            if (docItemReplacementLogRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Doc item replacement log', detail: docItemReplacementLogRes.data.error, life: 3000}))
            }
            const relatedDocItemReplacementMapIds = docItemReplacementLogRes?.data?.map(eachDocItemLog => eachDocItemLog?.docItemReplacementMapId)
            let relatedDocItemReplacementMapRes
            if (docItemReplacementLogRes?.data?.length > 0){
                relatedDocItemReplacementMapRes = await getDocItemReplacementMapByIds({docItemReplacementMapIds : relatedDocItemReplacementMapIds})
                console.log("relatedDocItemReplacementMapRes", relatedDocItemReplacementMapRes)
            }
    
            if (relatedDocItemReplacementMapRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Doc Item replacement map', detail: relatedDocItemReplacementMapRes.data.error, life: 3000}))
            }

            let buyerReqItemsIds = buyerInvoiceItemsRes?.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqItemId)
            let data = {
                buyerReqItemsIds : buyerReqItemsIds
            }
            const materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds(data)
            if (materialDetailsRes?.data?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Material Details', detail: materialDetailsRes.data.error, life: 3000}))
            }

            setBuyerInvoice(buyerInvoiceRes?.data?.buyerInvoice)
            setBuyerInvoiceItems(buyerInvoiceItemsRes?.data)
            setPMBankAccountDetails(buyerInvoiceRes?.data?.PMBankAccountDetails)
            setPMCompanyBillAddrDetails(buyerInvoiceRes?.data?.pmCompanyBillAddrDetails)
            setBuyerBillAddrDetails(buyerInvoiceRes?.data?.buyerBillAddrDetails)
            setBuyerShipAddrDetails(buyerInvoiceRes?.data?.buyerShipAddrDetails)
            setMaterialDetails(materialDetailsRes?.data)
        }

        const relatedApproval = CNDNApprovals.find(eachApr => eachApr.approvalTypeId === 8) // APPROVAL_CHANGE find by typeId
        if(relatedApproval?.primaryApprover){
            const primaryApproverRes = await getUsers({paginator: false, userIds: [relatedApproval.primaryApprover]})

            if(primaryApproverRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'primaryApproverRes', detail: primaryApproverRes.data.error, life: 3000}))
            }

            setCreditNoteApproverDetails(primaryApproverRes.data.data[0])
        }

        const approvalInstanceRes = await getApprovalInstances({docIds: [adjustmentNoteId], statusIds: [12, 8, 9], parentDocNos: [buyerInvoiceRes?.data?.buyerInvoice.docNo]})
        if (approvalInstanceRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Approval instances', detail: approvalInstanceRes.data.error, life: 3000 }))
        }

        const sellerDebitNoteRes = await getAdjustmenyNoteByLinkedDocNo({linkedDocNo: adjustmentNoteRes.data.adjustmentNotes.docNo})
        if (sellerDebitNoteRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Linked seller debit Note', detail: sellerDebitNoteRes.data.error, life: 3000 }))
        }

        setLinkedSellerDebitNote(sellerDebitNoteRes.data.adjustmentNote)

        if(approvalInstanceRes.data.data.length){
            setApprovalInstance(approvalInstanceRes.data.data[0])
        }

        setIsLoading(false)
    }

    const getBuyerCreditNotePDFURL = async () => {
        let generateIfNotExists = true
        const docCopyRes = await getDocCopyByDocNo(adjustmentNote.docNo, generateIfNotExists)

        let summary = adjustmentNote?.adjustmentTypeId === 1 ? "Buyer Credit Note Document" : "Buyer Debit Note Document"
        let detail = adjustmentNote?.adjustmentTypeId === 1 ? "Buyer Credit Note document was not found." : "Buyer Debit Note document was not found."
        let fileName =  adjustmentNote?.adjustmentTypeId === 1 ? "buyerCreditNote.pdf" : "buyerDebitNote.pdf"

        if(docCopyRes.failure){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: summary, detail:docCopyRes.data.error, life: 3000}))
        }
        
        if(!docCopyRes?.docLocation){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: summary, detail: detail, life: 3000}))
        }

        downloadFile(docCopyRes.docLocation, fileName)
        setIsPDFLoading(false)
    }

    const renderHTMLInvoiceDocument = () => {
        console.log("HTML Trigger")
        
        let watermark = ''

        if(adjustmentNote?.statusId === 6){
            watermark = "cancelled-watermark"
        }else if([1, 7].includes(adjustmentNote?.statusId) && !adjustmentNote?.docNo){
            console.log("approvalInstance", approvalInstance)
            if(approvalInstance?.statusId === 9){
                watermark = 'approved-watermark'
            }else if(approvalInstance?.statusId === 8){
                watermark = 'rejected-watermark'
            }else if(approvalInstance?.statusId === 12){
                watermark = 'requested-watermark'
            } else {
                watermark = 'preview-watermark'
            }
        }

        const sanitizedHTML = DOMPurify.sanitize(buyerCreditNoteHTML)

        return(
            <div className={watermark} >
                {Parser(sanitizedHTML)}
            </div>
        )
    }

    const renderAdjustmentNotePDF = (adjustmentNotePDFURL) => {
        return(
            <div className="" style={{width: '210mm'}}>
                <DocumentView fileUrl={adjustmentNotePDFURL} />
            </div>
        )
    }

    const handleCancelAdjustmentNote = async () => {
        const createdDate = moment(adjustmentNote.createdAt)
        const currentDate = moment(new Date())
        const duration = currentDate.diff(createdDate, 'hours')

        if(adjustmentNote.docNo){
            if(![2].includes(adjustmentNote.supplyTypeId) && adjustmentNote.IRN && duration > 24){
                return dispatch(raiseToast({severity:'error', detail: "Cant cancel invoice past 24 hours of generation", life: 3000}))
            } else if([2].includes(adjustmentNote.supplyTypeId) && duration > 24) {
                return dispatch(raiseToast({severity:'error', detail: "Cant cancel invoice past 24 hours of generation", life: 3000}))
            }
        }

        let summary = adjustmentNote?.adjustmentTypeId === 1 ? "Buyer Credit Note Document" : "Buyer Debit Note Document"
        let detail = adjustmentNote?.adjustmentTypeId === 1 ? "Buyer Credit Note document cancelled succesfully" : "Buyer Debit Note document cancelled succesfully"

        let confirmationtext = 'Are you sure you want to continue?'
        if(linkedSellerDebitNote){
            confirmationtext = `This credit note is linked with seller debit note ${linkedSellerDebitNote.docNo}. Cancelling this credit note will auotmatically cancel the seller debit note. \nAre you sure you want to continue?`
        }

        const accept = async () => {
            setIsPageLoading(true)
            const updatedAdjustmentNoteRes = await cancelBuyerCreditNoteEInvoice(adjustmentNoteId, {cancelRemarks: cancelRemarks})
            if (updatedAdjustmentNoteRes.failure) {
                setIsPageLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Cancel Adjustment Note', detail: updatedAdjustmentNoteRes.data.error, life: 3000 }))
            }

            if(adjustmentNote.statusId === 7 && [12,8].includes(approvalInstance?.statusId)){

                const updatedApprovalInstance = {
                    ...approvalInstance,
                    statusId: 2
                }

                const approvalInstacesRes = await updateApprovalInstance(updatedApprovalInstance)
                if (approvalInstacesRes.failure) {
                    setIsPageLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Approval Requests', detail: approvalInstacesRes.data.error, life: 3000 }))
                }else{
                    setApprovalInstance(approvalInstacesRes.data)
                }
            }
            
            if(updatedAdjustmentNoteRes?.failure){
                dispatch(raiseToast({severity:'error', summary: summary, detail: updatedAdjustmentNoteRes.data.error, life: 3000}))
            }else{
                dispatch(raiseToast({severity:'success', detail: detail, life: 3000}))
                setVisibleCancelCreditNote(false)
                getAdjustmentNoteDetails()
            }
            setIsPageLoading(false)
        }

        const reject = () => {
            //Nothing happens for now
        }

        confirmDialog({
            message: confirmationtext,
            header: 'Cancel Seller Debit Note',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: "No",
            acceptLabel: "Yes",
            accept,
            reject
        })
    }

    const handleGenerateEwayBill = () => {
        let productDetails = []
        let totalAmountBeforeTax = 0
        let totalAmountWithTax = 0
        let totalInvAmount = 0
        let totalInvTax = 0

        adjustmentNoteItems?.map(eachAdjustmentNoteItem => {
            const relatedBuyerInvoiceItem = buyerInvoiceItems?.find(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceItemId === eachAdjustmentNoteItem?.buyerInvoiceItemId)
            const isIGST = pmCompanyBillAddrDetails?.stateId === buyerBillAddrDetails?.stateId ? false : true

            let itemAmountBeforeTax = eachAdjustmentNoteItem?.adjustedQty * relatedBuyerInvoiceItem?.unitPrice
            let itemAmountWithTax = itemAmountBeforeTax + itemAmountBeforeTax * relatedBuyerInvoiceItem?.GSTRate * 0.01


            const IGSTTaxRate = isIGST ? relatedBuyerInvoiceItem?.GSTRate : 0
            const IGSTTax = IGSTTaxRate * itemAmountBeforeTax * 0.01
            const CGSTTaxRate = !isIGST ? (relatedBuyerInvoiceItem?.GSTRate/2): 0
            const CGSTTax = CGSTTaxRate * itemAmountBeforeTax * 0.01
            const SGSTTaxRate = !isIGST ? (relatedBuyerInvoiceItem?.GSTRate / 2): 0
            const SGSTTax = SGSTTaxRate * itemAmountBeforeTax * 0.01
            let newProduct = {
                materialId: relatedBuyerInvoiceItem?.materialId,
                HSNCode: relatedBuyerInvoiceItem?.HSNCode,
                qty: eachAdjustmentNoteItem?.adjustedQty,
                unitPrice: relatedBuyerInvoiceItem?.unitPrice,
                itemAmountBeforeTax: itemAmountBeforeTax,
                itemAmountWithTax: itemAmountWithTax,
                GSTRate: relatedBuyerInvoiceItem?.GSTRate,
                IGSTTax: IGSTTax,
                IGSTTaxRate: IGSTTaxRate,
                CGSTTax: CGSTTaxRate,
                CGSTTaxRate: CGSTTaxRate,
                SGSTTax: SGSTTax,
                SGSTTaxRate: SGSTTaxRate,
                buyerReqItemId: relatedBuyerInvoiceItem?.buyerReqItemId
            }
            totalAmountBeforeTax += itemAmountBeforeTax
            totalAmountWithTax += itemAmountWithTax
            totalInvTax += IGSTTax + CGSTTax + SGSTTax
            productDetails.push(newProduct)
        })
        let invoiceObj = {
            docNo: adjustmentNote?.docNo,
            fileNo: adjustmentNote?.fileNo,
            pmBillAddrId: buyerInvoice?.pmBillAddrId,
            billAddrId: buyerInvoice?.billAddrId,
            shipAddrId: buyerInvoice?.shipAddrId,
            adjustmentNoteId: adjustmentNote?.adjustmentNoteId
        }
        invoiceObj.totalAmountBeforeTax = totalAmountBeforeTax
        invoiceObj.totalAmountWithTax = totalAmountWithTax
        invoiceObj.totalInvAmount = parseInt(totalAmountWithTax)
        invoiceObj.totalInvTax = totalAmountWithTax - totalAmountBeforeTax

        setEWayBillInvoiceObj(invoiceObj)
        setEWayBillProductDetails(productDetails)
        setIsEwayBillVisible(true)
    }

    const handleGenerateEInvoice = async () => {
        if(window.confirm(`Are you sure you want to generate E-invoice`)){
            setIsPageLoading(true)
            const creditNoteEInvoiceRes = await generateBuyerCreditNoteEInvoice({adjustmentNote, adjustmentNoteItems, buyerInvoice, buyerInvoiceItems})

            if(creditNoteEInvoiceRes.failure){
                setIsPageLoading(false)
                return dispatch(raiseToast({severity:'error', detail: creditNoteEInvoiceRes.data.error, life: 3000}))
            } else {
                if(creditNoteEInvoiceRes.data?.docCopy?.docLocation){
                    setAdjustmentNote(creditNoteEInvoiceRes.data?.adjustmentNote)
                    setAdjustmentNotePDFURL(creditNoteEInvoiceRes.data?.docCopy?.docLocation)
                }
            }
            setIsPageLoading(false)
        }
    }

    return(
        <>
            <div className="pb-3 document-page document-page-height">
                <div className="mb-2 document-page-container">
                    <div className="flex justify-content-end">
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                </div>

                <div className="relative document-y-scroll">
                    {
                        !isLoading &&
                        (
                            adjustmentNotePDFURL ?
                                renderAdjustmentNotePDF(adjustmentNotePDFURL)
                                :
                                renderHTMLInvoiceDocument()
                        )
                    }
                    {
                        adjustmentNote?.eInvoiceJSON ?
                            <div className={`credit-note-einvoice-qrcode-mask ${ adjustmentNotePDFURL ? 'credit-note-qrcode-mask-on-pdf' : 'credit-note-qrcode-mask-on-html'}`} onClick={() => setVisibleEInvoiceDetails(true)}>
                                <i className="pi pi-eye credit-note-einvoice-mask-eye text-3xl" aria-hidden="true"></i>
                            </div> : null
                    }
                </div>

                <Loading visible={isLoading || isPageLoading}/>
                <Dialog header="Generate E-Way Bill" className='pi-punch-dialog' visible={isEwayBillVisible} style={{ width: '95vw', height: '80vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsEwayBillVisible(false)}>
                    <GenerateEwayBill 
                        buyerInvoice = {buyerInvoice} 
                        buyerInvoiceItems = {buyerInvoiceItems} 
                        materialDetails = {materialDetails} 
                        pmCompanyBillAddrDetails = {pmCompanyBillAddrDetails} 
                        buyerBillAddrDetails = {buyerBillAddrDetails} 
                        buyerShipAddrDetails = {buyerShipAddrDetails} 
                        statesList = {statesList}
                        invoiceObj={eWayBillInvoiceObj}
                        productDetails={eWayBillProductDetails}
                        docType="creditNote"
                    />
                </Dialog>   
                <Dialog header={`CANCEL ${adjustmentNote?.adjustmentTypeId === 1 ? 'CREDIT' : 'DEBIT'} NOTE`} visible={visibleCancelCreditNote} style={{ width: '30vw', minHeight: "50vh" }} onHide={() => setVisibleCancelCreditNote(false)}>
                    <CancelCreditNoteModal 
                        handleCancelAdjustmentNote={handleCancelAdjustmentNote} 
                        cancelRemarks={cancelRemarks} 
                        setCancelRemarks={setCancelRemarks} 
                        setVisibleCancelCreditNote={setVisibleCancelCreditNote} 
                        adjustmentNote={adjustmentNote}
                    />
                </Dialog>
                <Dialog header="EINVOICE DETAILS" className="" visible={visibleEInvoiceDetails} style={{ minHeight: "30vh" }} onHide={() => setVisibleEInvoiceDetails(false)}>
                    <EInvoiceDetails eInvoiceDetails={adjustmentNote?.eInvoiceJSON} />
                </Dialog>
            </div>
        </>
    )
}

export default CreditNoteDocument;